import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
export function CookiebeleidPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1158" data-mp="1khz2fzkxo543">
      <SEO title="Cookiebeleid | Noord Digital" description="Lees het cookiebeleid van Noord Digital. Wij informeren je over het gebruik van cookies op onze website." canonical="https://noorddigital.nl/cookiebeleid" jsonLd={buildBreadcrumbList([{
      name: 'Cookiebeleid',
      path: '/cookiebeleid'
    }])} data-id="element-1159" data-mp="1fjnvpxpxqaq3" />
      <Header data-id="element-1160" data-mp="11tc03ou55tu7" />

      <main className="pt-32 pb-20" data-id="element-1161" data-mp="11tu2z4bb76b3">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-1162" data-mp="11qprdlvil8ae">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#111827]" data-id="element-1163" data-mp="wso8p2203azg">
            Cookiebeleid
          </h1>
          <p className="text-gray-500 italic mb-12" data-id="element-1164" data-mp="rwpegxtzqyr4">
            Dit cookiebeleid is voor het laatst geüpdatet op 13 augustus, 2025
            en is van toepassing op burgers en wettelijke permanente inwoners
            van de Europese Economische Ruimte en Zwitserland.
          </p>

          <div className="prose prose-lg max-w-none prose-headings:text-[#111827] prose-a:text-[#007AFF] prose-p:text-[#6B7280] prose-li:text-[#6B7280]" data-id="element-1165" data-mp="2cvo0c19vbpww">
            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1166" data-mp="35m6ebxc4rbp3">1. Introductie</h2>
            <p data-id="element-1167" data-mp="39nrk6yq8ypps">
              Op onze site, https://noorddigital.nl (hierna: "de site") wordt
              gebruikgemaakt van cookies en andere aanverwante technieken.
              (Hierna geldt dat alle technieken voor het gemak "cookies" worden
              genoemd). Ook via derden die door ons zijn ingeschakeld, worden
              cookies geplaatst. In het onderstaande document informeren wij je
              over het gebruik van cookies op onze site.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1168" data-mp="1p5tqztorcjhe">
              2. Wat zijn cookies?
            </h2>
            <p data-id="element-1169" data-mp="114golb27072i">
              Een cookie is een klein eenvoudig bestand dat samen met pagina's
              van deze site wordt verzonden en door je browser op de harde
              schijf van je computer of ander apparaat wordt opgeslagen. De
              daarin opgeslagen informatie kan tijdens een volgend bezoek terug
              worden gestuurd naar onze servers of naar de servers van de
              betreffende derde partijen.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1170" data-mp="hexvm42eweso">
              3. Wat zijn scripts?
            </h2>
            <p data-id="element-1171" data-mp="dh02wr9fnakj">
              Een script is een stukje programmacode dat wordt gebruikt om onze
              site goed te laten functioneren en interactief te maken. Deze code
              wordt uitgevoerd op onze server, of op je apparatuur.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1172" data-mp="22uvgcdpb37az">
              4. Wat is een web beacon?
            </h2>
            <p data-id="element-1173" data-mp="2actn4ag3s4ai">
              Een web beacon (ook pixel tag) is een klein, onzichtbaar stukje
              tekst of afbeelding op een site dat gebruikt wordt om verkeer op
              een site in kaart te brengen. Om dit te doen worden er met behulp
              van web beacons verschillende gegevens van je opgeslagen.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1174" data-mp="1reh1hp8091y1">5. Cookies</h2>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1175" data-mp="1rgbpxdihjc6v">
              5.1 Technische of functionele cookies
            </h3>
            <p data-id="element-1176" data-mp="21cogw3mnbbxx">
              Sommige cookies zorgen ervoor dat bepaalde onderdelen van de site
              goed werken en dat je gebruikers voorkeuren bekend blijven. Door
              het plaatsen van functionele cookies zorgen wij ervoor dat je onze
              site makkelijker kunt bezoeken. Op deze manier hoef je
              bijvoorbeeld niet steeds opnieuw dezelfde informatie in te voeren
              bij een bezoek aan onze site en is het onder andere mogelijk dat
              de artikelen in je winkelwagen bewaard blijven tot dat je hebt
              afgerekend. Deze cookies mogen wij plaatsen zonder dat je hier
              toestemming voor geeft.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1177" data-mp="3p832xmv96w2z">
              5.2 Statistieken cookies
            </h3>
            <p data-id="element-1178" data-mp="25gcyje3391n">
              Wij gebruiken statistieken cookies om de beleving voor onze
              gebruikers te optimaliseren. Wij krijgen door middel van
              statistieken cookies inzicht in het gebruik van onze site. Wij
              vragen je toestemming om statistieken cookies te plaatsen.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1179" data-mp="6xhkjs0b4blc">
              5.3 Marketing/Tracking cookies
            </h3>
            <p data-id="element-1180" data-mp="kwr0qroij5pb">
              Marketing/tracking cookies zijn cookies of enige andere vorm van
              lokale opslag, die worden gebruikt om gebruikersprofielen te maken
              met het doel om advertenties te tonen of om de gebruiker te volgen
              op deze of verschillende sites voor soortgelijke
              marketingdoeleinden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1181" data-mp="qj19vfqy1dlc">5.4 Sociale media</h3>
            <p data-id="element-1182" data-mp="vh2vo8fr7r0i">
              Op onze site hebben wij inhoud van Instagram, LinkedIn en Facebook
              opgenomen om webpagina's te promoten (bijv. "vind ik leuk", "pin")
              of te delen (bijv. "tweet") op sociale netwerken zoals Instagram,
              LinkedIn en Facebook. Deze inhoud is ingesloten met code die is
              afgeleid van Instagram, LinkedIn en Facebook en plaatst cookies.
              Deze inhoud kan bepaalde informatie opslaan en verwerken voor
              gepersonaliseerde reclame.
            </p>
            <p data-id="element-1183" data-mp="3tzgubp8lr0al">
              Lees de privacyverklaring van deze partijen door (welke regelmatig
              kunnen wijzigen) om te weten wat zij met je (persoons)gegevens
              doen die zij via deze cookies verwerken. De informatie die zij
              verzamelen, wordt zo veel mogelijk geanonimiseerd. Instagram,
              LinkedIn en Facebook zijn gevestigd in de Verenigde Staten.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1184" data-mp="1vnf0gkxn3kbl">
              6. Geplaatste cookies
            </h2>

            <div className="space-y-8 mt-6" data-id="element-1185" data-mp="1qolleo2pfl9b">
              {/* WordPress */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1186" data-mp="2nfw6p7ua31v5">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1187" data-mp="2jgey45jk1olr">
                  WordPress
                </h3>
                <p className="text-sm mb-4" data-id="element-1188" data-mp="2ee689i1zb2nv">
                  <span className="font-semibold" data-id="element-1189" data-mp="29hfqmqaizz0c">Doel:</span> Functional,
                  Functioneel
                </p>
                <p className="text-sm mb-4" data-id="element-1190" data-mp="131n79x224pek">
                  We gebruiken WordPress voor website ontwikkeling.
                </p>
                <div className="overflow-x-auto" data-id="element-1191" data-mp="y3u47cw1wbii">
                  <table className="min-w-full text-sm text-left" data-id="element-1192" data-mp="nyltjawst0ph">
                    <thead className="bg-gray-100 text-gray-700" data-id="element-1193" data-mp="swx27ibcx564">
                      <tr data-id="element-1194" data-mp="sx6trac1vkdx">
                        <th className="px-4 py-2 rounded-tl-lg" data-id="element-1195" data-mp="xw06v1nfd9dk">Naam</th>
                        <th className="px-4 py-2" data-id="element-1196" data-mp="xup517djibp3">Expiratie</th>
                        <th className="px-4 py-2 rounded-tr-lg" data-id="element-1197" data-mp="12ns05jxytt7e">Functie</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-1198" data-mp="16o24yta0udko">
                      <tr data-id="element-1199" data-mp="1bmlpqqcvpjbg">
                        <td className="px-4 py-2 font-mono" data-id="element-1200" data-mp="1bltwhm6r7xoc">
                          WP_PREFERENCES_USER_*
                        </td>
                        <td className="px-4 py-2" data-id="element-1201" data-mp="1llkpfjfo24mb">persistent</td>
                        <td className="px-4 py-2" data-id="element-1202" data-mp="1lkt6p97641dg">Store user preferences</td>
                      </tr>
                      <tr data-id="element-1203" data-mp="3ifpa82cxdyeh">
                        <td className="px-4 py-2 font-mono" data-id="element-1204" data-mp="3ncxwae172ml0">wp-settings-*</td>
                        <td className="px-4 py-2" data-id="element-1205" data-mp="3nf1y8qfj9bin">persistent</td>
                        <td className="px-4 py-2" data-id="element-1206" data-mp="1t3sppdqpvqwa">Store user preferences</td>
                      </tr>
                      <tr data-id="element-1207" data-mp="1o57pvffdn98d">
                        <td className="px-4 py-2 font-mono" data-id="element-1208" data-mp="1o3wm3flxm1h9">
                          wp-settings-time-*
                        </td>
                        <td className="px-4 py-2" data-id="element-1209" data-mp="1xw27u7llbmo0">1 year</td>
                        <td className="px-4 py-2" data-id="element-1210" data-mp="1xxwy81fms6zh">Store user preferences</td>
                      </tr>
                      <tr data-id="element-1211" data-mp="1a8c2ehydpf8s">
                        <td className="px-4 py-2 font-mono" data-id="element-1212" data-mp="157em6awxiv9x">
                          wordpress_test_cookie
                        </td>
                        <td className="px-4 py-2" data-id="element-1213" data-mp="1j7pdtg62cdw5">session</td>
                        <td className="px-4 py-2" data-id="element-1214" data-mp="1f5kkkijj1ja1">
                          Read if cookies can be placed
                        </td>
                      </tr>
                      <tr data-id="element-1215" data-mp="2uk9rivqzvqzf">
                        <td className="px-4 py-2 font-mono" data-id="element-1216" data-mp="2qkhlapp2pwx8">
                          wordpress_logged_in_*
                        </td>
                        <td className="px-4 py-2" data-id="element-1217" data-mp="2y2yzh97w9zwj">persistent</td>
                        <td className="px-4 py-2" data-id="element-1218" data-mp="332tthlmyv5lt">Store logged in users</td>
                      </tr>
                      <tr data-id="element-1219" data-mp="2o62qz3hzxdrz">
                        <td className="px-4 py-2 font-mono" data-id="element-1220" data-mp="2o6vzoa0imdcr">
                          wpEmojiSettingsSupports
                        </td>
                        <td className="px-4 py-2" data-id="element-1221" data-mp="2t7095g30a7th">sessie</td>
                        <td className="px-4 py-2" data-id="element-1222" data-mp="3gvji7xtvqomm">
                          Opslaan van browserspecificaties
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Elementor */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1223" data-mp="3c305f330nxiv">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1224" data-mp="3ngdc7e30l5e">
                  Elementor
                </h3>
                <p className="text-sm mb-4" data-id="element-1225" data-mp="8fq9i55sihg4">
                  <span className="font-semibold" data-id="element-1226" data-mp="8gj8ul2f64o8">Doel:</span> Statistics
                  (anonymous)
                </p>
                <p className="text-sm mb-4" data-id="element-1227" data-mp="3ggkh7iptuifp">
                  We gebruiken Elementor voor content creatie.
                </p>
                <div className="overflow-x-auto" data-id="element-1228" data-mp="32fzx8j86egkm">
                  <table className="min-w-full text-sm text-left" data-id="element-1229" data-mp="32jfcbm1unpm1">
                    <thead className="bg-gray-100 text-gray-700" data-id="element-1230" data-mp="37ekwogflsw80">
                      <tr data-id="element-1231" data-mp="2sqzvis2ah72q">
                        <th className="px-4 py-2 rounded-tl-lg" data-id="element-1232" data-mp="2sposiugo43co">Naam</th>
                        <th className="px-4 py-2" data-id="element-1233" data-mp="2xi845lvsooeu">Expiratie</th>
                        <th className="px-4 py-2 rounded-tr-lg" data-id="element-1234" data-mp="2xjsxx9aac3bn">Functie</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-1235" data-mp="2op4snj4pmlmu">
                      <tr data-id="element-1236" data-mp="2ona7c3pj0ri8">
                        <td className="px-4 py-2 font-mono" data-id="element-1237" data-mp="29rvqrvhs5zgv">elementor</td>
                        <td className="px-4 py-2" data-id="element-1238" data-mp="2erh0n0yhns8d">persistent</td>
                        <td className="px-4 py-2" data-id="element-1239" data-mp="2eqyxrlhbmfrh">
                          Store performed actions on the website
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Google Analytics */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1240" data-mp="25560lsrrvgoe">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1241" data-mp="20406prmdlnda">
                  Google Analytics
                </h3>
                <p className="text-sm mb-4" data-id="element-1242" data-mp="2e2gbhd0oh3ss">
                  <span className="font-semibold" data-id="element-1243" data-mp="2a3h7bumrtb2e">Doel:</span> Statistics
                </p>
                <p className="text-sm mb-4" data-id="element-1244" data-mp="2nuvtgabz5sdo">
                  We gebruiken Google Analytics voor website statistieken.
                </p>
                <div className="overflow-x-auto" data-id="element-1245" data-mp="2ivt0ho99rcm2">
                  <table className="min-w-full text-sm text-left" data-id="element-1246" data-mp="2xsa8q6m5wb4e">
                    <thead className="bg-gray-100 text-gray-700" data-id="element-1247" data-mp="2xqfo6tesyl0u">
                      <tr data-id="element-1248" data-mp="2suqkcdvr2hyq">
                        <th className="px-4 py-2 rounded-tl-lg" data-id="element-1249" data-mp="2srch73f9i4q8">Naam</th>
                        <th className="px-4 py-2" data-id="element-1250" data-mp="2zxyfuybu001l">Expiratie</th>
                        <th className="px-4 py-2 rounded-tr-lg" data-id="element-1251" data-mp="34vgqct5hynbp">Functie</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-1252" data-mp="39ts073vskxtx">
                      <tr data-id="element-1253" data-mp="3el9u57zedy5e">
                        <td className="px-4 py-2 font-mono" data-id="element-1254" data-mp="3eml5ptz34a72">_ga</td>
                        <td className="px-4 py-2" data-id="element-1255" data-mp="3jkwfy5takmpt">2 years</td>
                        <td className="px-4 py-2" data-id="element-1256" data-mp="3jkd0cvr46aey">Store and count pageviews</td>
                      </tr>
                      <tr data-id="element-1257" data-mp="3noawqyp2174b">
                        <td className="px-4 py-2 font-mono" data-id="element-1258" data-mp="3slkk88svv8pi">_ga_*</td>
                        <td className="px-4 py-2" data-id="element-1259" data-mp="3sj831xuy92di">1 year</td>
                        <td className="px-4 py-2" data-id="element-1260" data-mp="1dymsxwrc2h3">Store and count pageviews</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Other services summarized for brevity but maintaining structure */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1261" data-mp="1vn3qnqfuok24">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1262" data-mp="1qweysa09dl2g">
                  Andere Diensten
                </h3>
                <p className="text-sm mb-4" data-id="element-1263" data-mp="1ly3ro71clonx">
                  Wij maken ook gebruik van cookies van de volgende diensten:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm" data-id="element-1264" data-mp="1gvuwr54x0cj6">
                  <li data-id="element-1265" data-mp="2ekerhfh4rljo">
                    <strong data-id="element-1266" data-mp="2eky6anbhhtth">LiteSpeed:</strong> Voor website hosting en caching
                    (_lscache_vary)
                  </li>
                  <li data-id="element-1267" data-mp="24na276rzn9yn">
                    <strong data-id="element-1268" data-mp="24mihiqzxiwn5">Google reCAPTCHA:</strong> Voor spampreventie
                    (rc::a, rc::b, rc::c)
                  </li>
                  <li data-id="element-1269" data-mp="1zqjm4jg6oed8">
                    <strong data-id="element-1270" data-mp="t8dblsg5ocp6">Google Maps:</strong> Voor het vertonen van kaarten
                  </li>
                  <li data-id="element-1271" data-mp="o9a503kj1yf3">
                    <strong data-id="element-1272" data-mp="o90nz5hgn1lj">YouTube:</strong> Voor het tonen van video's (GPS,
                    VISITOR_INFO1_LIVE, YSC, PREF)
                  </li>
                  <li data-id="element-1273" data-mp="2d1ehumjl92de">
                    <strong data-id="element-1274" data-mp="2hu7nrdqsmgr2">Facebook & LinkedIn:</strong> Voor social media
                    integratie en tracking
                  </li>
                  <li data-id="element-1275" data-mp="236mj3fe9s9h1">
                    <strong data-id="element-1276" data-mp="2374mcvzcnnyg">Diversen:</strong> Diverse functionele en
                    statistische cookies (waaronder cmplz_* voor cookie consent
                    beheer)
                  </li>
                </ul>
              </div>
            </div>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1277" data-mp="30tbrc6zkfibc">7. Toestemming</h2>
            <p data-id="element-1278" data-mp="2lw1jd7m4sukd">
              Wanneer je onze site voor het eerst bezoekt, tonen wij een pop-up
              met uitleg over cookies. Zodra je klikt op 'Voorkeuren opslaan'
              geef je ons toestemming om de categorieën cookies en plugins te
              gebruiken die je hebt geselecteerd in de pop-up en welke zijn
              omschreven in het cookiebeleid. Je kunt via je browser het
              plaatsen van cookies uitschakelen, je moet er dan wel rekening mee
              houden dat onze site dan mogelijk niet meer optimaal werkt.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1279" data-mp="3oqhs11gu7yao">
              8. Cookies in-/uitschakelen en verwijderen
            </h2>
            <p data-id="element-1280" data-mp="2hgnt61jqbh7">
              Je kunt je internet browser gebruiken om cookies automatisch of
              handmatig te verwijderen. Je kunt ook aangeven dat bepaalde
              cookies niet geplaatst mogen worden. Een andere optie is om de
              instellingen van je internetbrowser zo aan te passen dat je iedere
              keer dat er een cookie wordt geplaatst een bericht ontvangt.
              Raadpleeg voor meer informatie over deze opties de instructies in
              de Hulp sectie van je browser.
            </p>
            <p data-id="element-1281" data-mp="2r7gf9ekjrlxq">
              Let op: onze site werkt mogelijk niet optimaal als alle cookies
              zijn uitgeschakeld. Als je wel de cookies in je browser
              verwijdert, worden ze na je toestemming opnieuw geplaatst bij een
              nieuw bezoek aan onze site.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1282" data-mp="v4aco8s2sdvu">
              9. Je rechten met betrekking tot persoonsgegevens
            </h2>
            <p data-id="element-1283" data-mp="14vofapfbptt7">
              Je hebt de volgende rechten met betrekking tot je
              persoonsgegevens:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1284" data-mp="78pi8dkpyjus">
              <li data-id="element-1285" data-mp="7aacs371a2sn">
                Je hebt het recht om te weten waarom je persoonsgegevens nodig
                zijn, wat ermee gebeurt en hoe lang ze worden bewaard.
              </li>
              <li data-id="element-1286" data-mp="h86n4ss5ctpp">
                Recht op inzage: je kunt een verzoek indienen om inzage in de
                gegevens die we van je verwerken.
              </li>
              <li data-id="element-1287" data-mp="1skh481xj31eb">
                Recht op rectificatie en aanvulling: je hebt het recht om je
                persoonlijke gegevens aan te vullen, te corrigeren, te
                verwijderen of te blokkeren wanneer je maar wilt.
              </li>
              <li data-id="element-1288" data-mp="3d3b5bb8obfu1">
                Als je ons toestemming geeft om je gegevens te verwerken, heb je
                het recht om die toestemming in te trekken en je persoonlijke
                gegevens te laten verwijderen.
              </li>
              <li data-id="element-1289" data-mp="33cox423adrld">
                Recht om je gegevens over te dragen: je hebt het recht om al je
                persoonlijke gegevens op te vragen bij de
                verwerkingsverantwoordelijke en deze in hun geheel over te
                dragen aan een andere verwerkingsverantwoordelijke.
              </li>
              <li data-id="element-1290" data-mp="2pdz00mggvrx0">
                Recht op bezwaar: je kan bezwaar maken tegen de verwerking van
                je gegevens. Wij komen hieraan tegemoet, tenzij er gegronde
                redenen voor verwerking zijn.
              </li>
            </ul>
            <p data-id="element-1291" data-mp="imr844xuhel6">
              Om deze rechten uit te oefenen, neem contact met ons op. Verwijs
              naar de contactgegevens onderaan dit cookiebeleid. Als je een
              klacht hebt over hoe we met je gegevens omgaan, horen we graag van
              je, maar je hebt ook het recht om een klacht in te dienen bij de
              toezichthoudende autoriteit (de Autoriteit Persoonsgegevens).
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1292" data-mp="3iv9pylvptu25">
              10. Contactinformatie
            </h2>
            <p data-id="element-1293" data-mp="34v8e6bdwx27w">
              Voor vragen en/of opmerkingen met betrekking tot ons cookiebeleid
              en deze verklaring kun je contact met ons opnemen via de volgende
              contactinformatie:
            </p>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-100 mt-6" data-id="element-1294" data-mp="2v0zy4n62j1qm">
              <p className="font-semibold text-[#111827] mb-1" data-id="element-1295" data-mp="2zxyqp1a330mp">Noord Digital</p>
              <p className="mb-1" data-id="element-1296" data-mp="t8k2bq6s2ren">Nieuwestad 132C</p>
              <p className="mb-1" data-id="element-1297" data-mp="y63jaxuv1iaa">8911 DA Leeuwarden</p>
              <p className="mb-1" data-id="element-1298" data-mp="y5ttpbdq9d54">Nederland</p>
              <p className="mb-1" data-id="element-1299" data-mp="2io4jvnxn43gb">
                Site:{' '}
                <a href="https://noorddigital.nl" data-id="element-1300" data-mp="2imbcu7j47h7s">https://noorddigital.nl</a>
              </p>
              <p className="mb-1" data-id="element-1301" data-mp="2dr4elf8m74q9">
                E-mail:{' '}
                <a href="mailto:info@noorddigital.nl" data-id="element-1302" data-mp="2sf8zmpv53sc7">info@noorddigital.nl</a>
              </p>
              <p className="mb-0" data-id="element-1303" data-mp="2nn7j2rqxvfgd">
                Telefoonnummer: <a href="tel:+31857444047" data-id="element-1304" data-mp="2nlnyioy92i8s">+31 85 744 4047</a>
              </p>
            </div>

            <p className="text-sm text-gray-500 mt-8 italic" data-id="element-1305" data-mp="31gynjlptc958">
              Dit Cookiebeleid is gesynchroniseerd met cookiedatabase.org op 10
              augustus, 2025.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-1306" data-mp="36e8fb80ocww8" />
    </div>;
}